export interface CommonState {
  alert: AlertState;
  isSubscriptionModalOpen: boolean;
  isCreditModalOpen: boolean;
}

export enum AlertType {
  WARNING,
  SUCCESS,
  ERROR,
  INFO,
}

export interface AlertState {
  show: boolean;
  type: AlertType | null;
  for: "page" | "modal";
  messages:
    | { code: number; field: string | null; message: string | null }[]
    | null;
}
